<template>
  <div>
    <div class="custom-row" >
      <p>{{headTitle}}</p>
      <div class="modal-status-footer-wrap" slot="footer">
        <a-space size="small">
          <a-button
            v-for="btnItem in btnList"
            :key="btnItem.title"
            :type="btnItem.type"
            size="small"
            shape="round"
            @click="handleCb(btnItem)">
              {{btnItem.title}}
            </a-button>
        </a-space>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    headTitle: String,
    btnList: Array
  },
  data() {
    return {

    }
  },
  components: {

  },
  methods: {
    handleCb(item) {
      const { cb } = item
      if (cb) {
        this.$emit(cb)
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
